module.exports = __webpack_public_path__ + "img/empty-box.03f3a2ca.svg";